// Native, instance-scoped components. No auto-play or external dependencies.
class MoraSlider extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.slides = [...this.querySelectorAll('[data-mora-slide]')];
    if (!this.slides.length) return;
    this.dataset.enhanced = '';
    this.index = 0;
    const controls = this.querySelector('[data-mora-controls]');
    if (controls) controls.hidden = false;
    this.querySelector('[data-mora-prev]')?.addEventListener('click', () => this.show(this.index - 1), { signal });
    this.querySelector('[data-mora-next]')?.addEventListener('click', () => this.show(this.index + 1), { signal });
    document.addEventListener('shopify:block:select', e => {
      const i = this.slides.findIndex(s => s.dataset.blockId === e.detail?.blockId);
      if (i >= 0 && this.contains(e.target)) this.show(i);
    }, { signal });
    this.show(0);
  }
  show(index) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
    const status = this.querySelector('[data-mora-status]');
    if (status) status.textContent = `${this.index + 1} / ${this.slides.length}`;
  }
  disconnectedCallback() { this.controller?.abort(); }
}
class MoraTabs extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.tabs = [...this.querySelectorAll('[data-mora-tab]')];
    this.panels = [...this.querySelectorAll('[data-mora-panel]')];
    if (!this.tabs.length) return;
    this.dataset.enhanced = '';
    this.querySelector('[data-mora-tablist]').hidden = false;
    this.panels.forEach(p => {
      p.setAttribute('role', 'tabpanel');
      p.setAttribute('aria-labelledby', this.tabs.find(t => t.dataset.moraTab === p.dataset.moraPanel).id);
      p.tabIndex = 0;
    });
    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.show(i), { signal });
      tab.addEventListener('keydown', e => {
        let index;
        if (e.key === 'ArrowRight') index = (i + 1) % this.tabs.length;
        else if (e.key === 'ArrowLeft') index = (i - 1 + this.tabs.length) % this.tabs.length;
        else if (e.key === 'Home') index = 0;
        else if (e.key === 'End') index = this.tabs.length - 1;
        else return;
        e.preventDefault(); this.show(index); this.tabs[index].focus();
      }, { signal });
    });
    document.addEventListener('shopify:block:select', e => {
      const i = this.panels.findIndex(p => p.dataset.moraPanel === e.detail?.blockId);
      if (i >= 0 && this.contains(e.target)) this.show(i);
    }, { signal });
    this.show(0);
  }
  show(index) {
    this.tabs.forEach((t, i) => { t.setAttribute('aria-selected', String(i === index)); t.tabIndex = i === index ? 0 : -1; });
    this.panels.forEach((p, i) => { p.hidden = i !== index; });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('mora-slider')) customElements.define('mora-slider', MoraSlider);
if (!customElements.get('mora-tabs')) customElements.define('mora-tabs', MoraTabs);
